import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { getProfileDetails } from "store/actions/authAction"
import Spinners from "components/Shared/Spinners"

const UserProfile = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // State to manage active tab
  const [activeTab, setActiveTab] = useState("general")
  const { loading, isLoading, userDetails } = useSelector(state => state.Login)

  // Function to toggle tabs
  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  useEffect(() => {
    getDetails()
  }, [])

  console.log(userDetails)

  const getDetails = () => {
    const uuid = localStorage.getItem("uuid")
    dispatch(getProfileDetails(uuid))
  }

  //meta title
  document.title = t("Profile | SAR")

  const { userType } = useSelector(state => state.Login)

  const documentsObject =
    !loading && userDetails?.documents
      ? userDetails.documents.reduce((acc, doc) => {
          if (doc.file_type && doc.file_url) {
            acc[doc.file_type] = doc.file_url // Store the file_url for each file_type
          }
          return acc
        }, {})
      : {} // Ensure documentsObject is always an object

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col lg="12">
                <h4 className="card-title mb-4">User Profile</h4>

                {userType === "candidate" && (
                  <>
                    {/* Tabs Navigation */}
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={activeTab === "general" ? "active" : ""}
                          onClick={() => toggleTab("general")}
                        >
                          General Information
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={activeTab === "bank" ? "active" : ""}
                          onClick={() => toggleTab("bank")}
                        >
                          Bank Information
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={activeTab === "job" ? "active" : ""}
                          onClick={() => toggleTab("job")}
                        >
                          Job Information
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={activeTab === "documents" ? "active" : ""}
                          onClick={() => toggleTab("documents")}
                        >
                          Documents
                        </NavLink>
                      </NavItem>
                    </Nav>

                    {/* Tab Content */}
                    <TabContent activeTab={activeTab} className="py-3">
                      {/* General Information Tab */}
                      <TabPane tabId="general">
                        <Card>
                          <CardBody>
                            <Table className="table-wrap mb-0">
                              <tbody>
                                <tr>
                                  <th scope="row">{t("Id")}</th>
                                  <td>{userDetails?.user_information?.id}</td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("First Name")}</th>
                                  <td>
                                    {userDetails?.user_information?.first_name}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Middle Name")}</th>
                                  <td>
                                    {userDetails?.user_information
                                      ?.middle_name || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Last Name")}</th>
                                  <td>
                                    {userDetails?.user_information?.last_name}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Phone Number")}</th>
                                  <td>
                                    {userDetails?.user_information?.phone_code}{" "}
                                    {
                                      userDetails?.user_information
                                        ?.phone_number
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("National Id")}</th>
                                  <td>
                                    {userDetails?.user_information?.national_id}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Registered Year")}</th>
                                  <td>
                                    {
                                      userDetails?.user_information
                                        ?.registered_year
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    {t("National Id Expire Date")}
                                  </th>
                                  <td>
                                    {userDetails?.user_information
                                      ?.national_id_exp_date || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Last Logged In At")}</th>
                                  <td>
                                    {
                                      userDetails?.user_information
                                        ?.last_logged_in_at
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Nationality")}</th>
                                  <td>
                                    {" "}
                                    {
                                      userDetails?.job_application
                                        ?.nationality_name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("DOB")}</th>
                                  <td> {userDetails?.user_information?.dob}</td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Gender")}</th>
                                  <td>
                                    {" "}
                                    {userDetails?.user_information?.gender}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("City of Residence")}</th>
                                  <td>
                                    {userDetails?.job_application?.city_name}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </TabPane>

                      {/* Bank Information Tab */}
                      <TabPane tabId="bank">
                        <Card>
                          <CardBody>
                            <Table className="table-wrap mb-0">
                              <tbody>
                                <tr>
                                  <th scope="row">{t("Bank Name")}</th>
                                  <td>
                                    {" "}
                                    {userDetails?.job_application?.bank_name}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("IBAN Number")}</th>
                                  <td>
                                    {userDetails?.job_application?.bank_iban}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </TabPane>

                      {/* Job Information Tab */}
                      <TabPane tabId="job">
                        <Card>
                          <CardBody>
                            <Table className="table-wrap mb-0">
                              <tbody>
                                <tr>
                                  <th scope="row">
                                    {t("Educational Qualification")}
                                  </th>
                                  <td>
                                    {
                                      userDetails?.job_application
                                        ?.education_qualification_name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Specialization")}</th>
                                  <td>
                                    {
                                      userDetails?.job_application
                                        ?.specialization_name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Language")}</th>
                                  <td>
                                    {userDetails?.job_application?.languages?.map(
                                      item => item.name + ", "
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("Uniform Size")}</th>
                                  <td>
                                    {
                                      userDetails?.job_application
                                        ?.uniform_size_name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    {t(
                                      "Do you have chronic illnesses or health issues?"
                                    )}
                                  </th>
                                  <td>
                                    {userDetails?.job_application
                                      ?.has_health_issues
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                {userDetails?.job_application
                                  ?.has_health_issues && (
                                  <tr>
                                    <th scope="row">{t("Health Issues")}</th>
                                    <td>
                                      {
                                        userDetails?.job_application
                                          ?.health_issues
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th scope="row">
                                    {t(
                                      "Have you ever worked in crowd management at the Holy Train of the Sacred Sites?"
                                    )}
                                  </th>
                                  <td>
                                    {userDetails?.job_application
                                      ?.has_crowd_management_exp
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                {userDetails?.job_application
                                  ?.has_health_issues && (
                                  <tr>
                                    <th scope="row">
                                      {t("Crowd Management Exp")}
                                    </th>
                                    <td>
                                      {userDetails?.job_application?.crowd_management_exp?.map(
                                        item => (
                                          <div
                                            key={item?.job}
                                            className="d-flex align-items-center justify-content-between my-2  pe-3"
                                          >
                                            <h6>{item?.job_title}</h6>
                                            <h6 className="font-bold">
                                              {item?.station}
                                            </h6>
                                          </div>
                                        )
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </TabPane>

                      {/* Documents Tab */}
                      <TabPane tabId="documents">
                        <Card>
                          <CardBody>
                            <Table className="table-wrap mb-0">
                              <tbody>
                                <tr>
                                  <th scope="row">{t("Personal Photo")}</th>
                                  <td>
                                    <Link
                                      to={
                                        userDetails?.user_information
                                          ?.profile_picture || "#"
                                      }
                                      className="text-decoration-underline"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </Link>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("ID/Residence Image")}</th>
                                  <td>
                                    <Link
                                      to={documentsObject["National_ID"] || "#"}
                                      className="text-decoration-underline"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </Link>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">{t("CV")}</th>
                                  <td>
                                    <Link
                                      to={documentsObject["CV"] || "#"}
                                      className="text-decoration-underline"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </Link>
                                  </td>
                                </tr>
                                {documentsObject["Supportind_Document"] && (
                                  <tr>
                                    <th scope="row">
                                      {t("Supporting Document")}
                                    </th>
                                    <td>
                                      <Link
                                        to={
                                          documentsObject[
                                            "Supportind_Document"
                                          ] || "#"
                                        }
                                        className="text-decoration-underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View
                                      </Link>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </TabPane>
                    </TabContent>
                  </>
                )}

                {userType === "superadmin" && (
                  <Card>
                    <CardBody>
                      <Table className="table-wrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{123}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("First Name")}</th>
                            <td>{"Akhlak"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Middle Name")}</th>
                            <td>Ahmed</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Last Name")}</th>
                            <td>Patel</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Phone Number")}</th>
                            <td>+966 545874545</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("National Id")}</th>
                            <td>545874545</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("National Id Expire Date")}</th>
                            <td>02-03-2029</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Nationality")}</th>
                            <td>Saudi</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("DOB")}</th>
                            <td>10-02-1992</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Gender")}</th>
                            <td>Male</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("City of Residence")}</th>
                            <td>Makkah</td>
                          </tr>
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
